import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GoalService } from '@EYN/components';
import { Observable } from 'rxjs/internal/Observable';

// TODO: Should move to CanAccessPlanEditGuard since that does not do magic in service and works just as guard
@Injectable()
export class CanActivateEditPlan implements CanActivate {
	constructor(private goalService: GoalService) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
		const {planId} = route.params;
		this.goalService.goToPlanEditPage(parseInt(planId));
		return false;
	}
}
